var App = App || {};

App.AlertsWidget = (function () {
    var activeElement = undefined;

    return {
        init: init
    };

    function init() {
        alertKeyPress();
        alertLinks();
        triggerAlertModalOnRedirect();

        $(document).on('click', '.js-alerts-sign-up-wrapper .js-focus-element', taxonomyItemClick);
    }

    function alertKeyPress() {
        $(document).on('.js-user-alert', 'keydown', function (event) {
            if (event.key === 'Enter') {
                //The triggerHandler( "event" ) method will not call .event() on the element it is triggered on. This is to 
                //avoid conflict with the actual click being detected in ns.alertLinks.
                //This is an odd use case of the user tabbing through the entire issue page directly to the alerts and pressing enter or return.
                //Because ns.alertLinks is using each for a common class, rather than using .trigger, .triggerHandler() only affects the first matched element.
                $(this).triggerHandler('click');
            } else {
                return;
            }
        });
    }

    function showSignUpAlertInfo (userAlert) {
        $.ajax({
            url: (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/Toolbox/AlertsSignUp/AlertsSignUpPopup',
            cache: false,
            data: {
                alertType: userAlert.data('alerttype'),
                resourceId: userAlert.data('alertresourceid'),
                resourceType: userAlert.data('alertresourcetype'),
                email: userAlert.data('alertuseremail'),
                resourceName: userAlert.data('alertresourcename'),
                taxonomyName: userAlert.data('alerttaxonomyname')
            },
            dataType: 'html',
            success: function (data) {
                $('.userAlertSignUp').html(data);
                var $userAlertSignUpModal = $('.userAlertSignUpModal');
                var $closeBtn = $userAlertSignUpModal.find('.close-reveal-modal');

                // register modal open event
                $userAlertSignUpModal.off('opened.fndtn.reveal');
                $userAlertSignUpModal.on('opened.fndtn.reveal', function () {
                    SCM.trapFocus.publicTrapFocus($userAlertSignUpModal, $closeBtn, userAlert);
                    $userAlertSignUpModal.focus();
                });
                // open the alert modal
                $userAlertSignUpModal.foundation('reveal', 'open');

                var scheduleSelect = $('.userAlertSignUp').find('#selectAlertFreqeuncy');

                App.TaxonomyFacet.initTaxonomyArrows($('.userAlertSignUp'));
                App.SolrFacet.collapseFacets();

                $('.addUserAlert').on('click', function () {
                    lastActiveElement = document.activeElement;
                    var mainForm = $(this).parent();
                    var alertName = $(this).parent().find('.js-alert-name').val();
                    var taxonomies = $(this).parent().find('.js-taxonomy-checkbox:checked');

                    var error = false;
                    var errorMessage;
                    if (userAlert.data('alerttype') == 33) { // if it's a taxonomy search alert
                        if (!alertName) {
                            error = true;
                            SCM.SiteJS.showErrorMessage(mainForm, $('#errorAlertNameRequired'));
                        }
                        else if (taxonomies.length < 1) {
                            error = true;
                            SCM.SiteJS.showErrorMessage(mainForm, $('#errorSelectionRequired'));
                        }
                    }

                    // get all toplevel checked taxonomies (taxonomy search will automatically fill in child taxonomies)
                    var taxonomiesFiltered = taxonomies.filter(App.TaxonomyFacet.taxonomyFilterFunction);
                    var taxonomyIds = SCM.SiteJS.processTaxonomies(taxonomiesFiltered);
                    if (!error) {
                        SCM.SiteJS.addSignUpAlert(userAlert, scheduleSelect, alertName, taxonomyIds, mainForm);
                    }
                });
            }
        });
    }

    function alertLinks () {
        // register .js-user-alert click and .close-reveal-modal click events

        $(document).on('click', '.js-user-alert', function () {
            var userAlert = $(this);

            //Remember element clicked to return focus after closing modal in function showSignUpAlertInfo.
            activeElement = userAlert;
            var marketingUrl = userAlert.data('additionalurl');
            var isUserLoggedIn = userAlert.data('userloggedin');
            var alerttype = userAlert.data('alerttype');
            var siteid = userAlert.data('siteid');
            if (isUserLoggedIn !== undefined && isUserLoggedIn.toLowerCase() === 'false') {
                var returnUrl = SCM.JSUtility.getSearchParamByName('returnUrl');

                if (siteid === undefined) {
                    siteid = $('#hdnSiteID').val();
                }
                //override the returnUrl for New Issue Alert and Marketing Alert
                if (userAlert.parent().hasClass('alertType-MarketingLink')) {
                    returnUrl = marketingUrl;
                }

                if (returnUrl === undefined || returnUrl === null) {
                    returnUrl = location.pathname + location.search;
                    if (!location.search.length || location.search.indexOf('fl_SiteID') === -1) {
                        returnUrl += location.search.length ? '&fl_SiteID=' + siteid : '?fl_SiteID=' + siteid;
                    }
                }

                if (alerttype !== undefined) {
                    returnUrl = returnUrl + '#trigger-alerttype' + alerttype;
                }

                var redirectSiteUrl = $('#RedirectSiteUrl').val();
                decodedUrl = SCM.ZEncoderV1.Decode(redirectSiteUrl)

                returnUrl = decodedUrl + returnUrl;

                window.location = '/sign-in?returnUrl=' + encodeURIComponent(returnUrl);
            } else if (marketingUrl !== undefined && marketingUrl.length) {
                window.location = marketingUrl;
            }
            else {
                if ((siteid === 191 || siteid === 192) && alerttype === 3) {
                    window.location = '/my-account/email-alerts';
                }
                else {
                    showSignUpAlertInfo(userAlert);
                }
            }
        })

        // see also scm.sharedcontrols.pdfaccess.js which also registers
        // an almost equivalent handler but which does not handle focus
        $(document).on('click', '.close-reveal-modal', function () {
            try {
                $(this).parents('.reveal-modal').foundation('reveal', 'close');
            } catch (ex) {
                console.log('Foundation error - pdfaccess : ' + ex);
            }

            //Return focus here.
            if (activeElement !== undefined) {
                activeElement.focus();
            }
        });
    }

    function triggerAlertModalOnRedirect () {
        var alertType = window.location.hash.substring(1);

        if (alertType !== undefined && alertType !== '') {
            var hashKey = "trigger-alerttype";
            var alertTypeID = alertType.replace(hashKey, "");
            $('.userAlert a[data-userloggedin="True"][data-alerttype="' + alertTypeID + '"]').trigger('click');
            window.location.replace(window.location.hash.replace(`${hashKey}${alertTypeID}`, ''));
        }
    }

    function taxonomyItemClick(e) {
        var $el = $(this);
        var $checkbox = $el.siblings('.js-taxonomy-checkbox').first();
        if ($checkbox.length) {
            if ($checkbox.is(':checked')) {
                $checkbox.prop('checked', false);
            } else {
                $checkbox.prop('checked', true);
            }
            App.TaxonomyFacet.updateTaxonomyTreeModal($checkbox);
        }
    }

})(jQuery);